import Handler from "../Handler";

class GPSStateBlockedHandler extends Handler {
  execute(message) {
    this.service.processGPSStateBlocked();
  }
}

export default GPSStateBlockedHandler;
